import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import {Box, Typography, useTheme, Stack, Divider, IconButton, Tooltip} from "@mui/material";
import {tokens} from "../theme";
import CachedSharpIcon from '@mui/icons-material/CachedSharp';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { useState, useEffect } from 'react';

const QueueStatus = ({open, handleClose, loading, handlePutQueue, handleUpdateQueue, queueStatus}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [errors, setErrors] = useState([])
    

    const clickUpdateQueue = () => {
        setErrors([])
        handleUpdateQueue().then(setErrors)
    }

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    <Stack
                        direction={'row'}
                        spacing={2}
                        alignItems={"center"}
                        justifyContent="space-between"
                    >
                        <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>Call-Center</Typography>
                        {loading &&
                            <IconButton type="button">
                                <CachedSharpIcon onClick={clickUpdateQueue}/>
                            </IconButton>
                        }
                    </Stack>
                    {!loading && <LinearProgress /> }
                    {errors.map((error) => {
                        return <Typography variant="subtitle2" fontStyle="italic" sx={{ color: colors.redAccent[600] }}>Error: {error}</Typography>
                    })}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        // ref={descriptionElementRef}
                        tabIndex={-1}
                        // p={5}
                    >
                        
                        <Stack spacing={3}>
                            {queueStatus.map((provider) => {
                                return <Provider provider={provider} handlePutQueue={handlePutQueue} setErrors={setErrors}></Provider>
                            })}
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

const Provider = ({ provider, handlePutQueue, setErrors}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center',}}
        >   
            <Stack
                height={"100%"}
                maxHeight={"100vh"}
                width={true ? "100vw" : "auto"}
            >
                {/*  */}
                <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>{ provider.provider_name }</Typography>
                <Divider color={colors.greenAccent[500]} sx={{ borderBottomWidth: '1.5px' }}/>
                {Object.entries(provider.queues).map(([name, queue]) => {
                        return (
                            <Box>
                                {queue
                                    ? <Queue name={name} queue={queue} sipOutExt={provider.sip_out_ext} agents={provider.agents ? provider.agents : {}} handlePutQueue={handlePutQueue} setErrors={setErrors}></Queue>
                                    : <Typography>No active queues</Typography>
                                }
                            </Box>
                        )
                })}
            </Stack>
        </Paper>
    );
};

const Queue = ({name, queue, sipOutExt, agents, handlePutQueue, setErrors}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [useMobile, setUseMobile] = useState(false)
    const [useSip, setUseSip] = useState(false)

    useEffect(() => {
        if (queue.Members) {
            queue.Members.forEach(function(item, i, arr) {
                if(item.StateInterface === "Local/" + agents.mobile + "@" + sipOutExt) {
                    setUseMobile(true)
                }
                for (const sip of agents.sip) {
                    if(item.StateInterface === "PJSIP/" + sip.sip) {
                        setUseSip(true)
                        break
                    }
                }
            });
        }
    }, [queue])

    const handleMobile = () => {
        if(useMobile) {
            queue.Members.forEach(function(item, i, arr) {
                if(item.StateInterface === "Local/" + agents.mobile + "@" + sipOutExt) {
                    queue.Members.splice(i, 1)
                    setUseMobile(false)
                }    
            });
        }
        else {
            const agent = {
                CallsTaken: "0",
                InCall: "0",
                LastCall: "0",
                LastPause: "0",
                Location: "Local/" + agents.mobile + "@" + sipOutExt,
                Membership: "dynamic",
                Name: "Local/" + agents.mobile + "@" + sipOutExt,
                Paused: "0",
                PausedReason: "",
                Penalty: "0",
                StateInterface: "Local/" + agents.mobile + "@" + sipOutExt,
                Status: "0",
                content: "",
            }
            queue.Members.push(agent)
            setUseMobile(true)
        }
        handlePutQueue().then(setErrors)
    }

    const handleSip = () => {
        if(useSip) {
            queue.Members.forEach(function(item, i, arr) {
                if(item.StateInterface === "PJSIP/" + agents.sip[0].sip) {
                    queue.Members.splice(i, 1)
                    setUseSip(false)
                }    
            });
        }
        else {
            const agent = {
                CallsTaken: "0",
                InCall: "0",
                LastCall: "0",
                LastPause: "0",
                Location: "PJSIP/" + agents.sip[0].sip,
                Membership: "dynamic",
                Name: "PJSIP/" + agents.sip[0].sip,
                Paused: "0",
                PausedReason: "",
                Penalty: "0",
                StateInterface: "PJSIP/" + agents.sip[0].sip,
                Status: "0",
                content: "",
            }
            queue.Members.push(agent)
            setUseSip(true)
        }
        handlePutQueue().then(setErrors)
    }

    return (
        <Box>
            <Stack direction={'row'} alignItems={"center"} mt={'2px'}
                        justifyContent="space-between">
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ color: colors.grey[100] }}
                >
                    Queue {name}
                </Typography>
                <Stack direction={'row'} spacing={2}>
                    {agents.mobile &&
                    <Tooltip title={agents.mobile} placement="bottom-start">
                        <IconButton type="button" onClick={handleMobile}>
                            {useMobile ? <PhoneAndroidIcon sx={{ color: colors.greenAccent[600]  }}/> : <PhoneAndroidIcon sx={{ color: colors.grey[700] }}/>}
                        </IconButton>
                    </Tooltip>
                    }
                    {agents.sip && agents.sip.length > 0 && 
                    <Tooltip title={agents.sip[0].sip} placement="bottom-start">
                        <IconButton type="button" onClick={handleSip}>
                            {useSip ? <HeadsetMicIcon sx={{ color: colors.greenAccent[600]  }}/> : <HeadsetMicIcon sx={{ color: colors.grey[700] }}/>}
                        </IconButton>
                    </Tooltip>
                    }
                </Stack>
            </Stack>
                {/*<Box>*/}
                {/*    <ProgressCircle progress={progress} />*/}
                {/*</Box>*/}
            
            {/* has 0 звонков (max unlimited) in 'rrmemory' strategy (20s holdtime, 108s talktime), W:100, C:186, A:15, SL:89.8%, SL2:87.6% within 60s */}
            <Box display="flex" justifyContent="space-between" mt="2px" width={'100%'}>
                <Stack alignItems={'center'}>
                    <Typography
                        variant="h5"
                        fontStyle="italic"
                        sx={{ color: colors.greenAccent[600] }}
                    >
                        {queue.Calls}
                    </Typography>
                    <Typography fontSize={10}>calls</Typography>
                </Stack>
                <Stack alignItems={'center'}>
                    <Typography
                        variant="h5"
                        fontStyle="italic"
                        sx={{ color: colors.greenAccent[600] }}
                    >
                        {queue.Holdtime}s
                    </Typography>
                    <Typography fontSize={10}>holdtime</Typography>
                </Stack>
                <Stack alignItems={'center'}>
                    <Typography
                        variant="h5"
                        fontStyle="italic"
                        sx={{ color: colors.greenAccent[600] }}
                    >
                        {queue.TalkTime}s
                    </Typography>
                    <Typography fontSize={10}>talktime</Typography>
                </Stack>
            </Box>
            <Divider />
            <Box p={1}>
                {queue.Members
                    ? <Members members={queue.Members}></Members>
                    : <Typography borderRadius={1} p={0.2} backgroundColor={colors.redAccent[600]}>No agents added</Typography>
                }
            </Box>
            {/* <Divider />
            {queue.ActiveCalls
                ? <ActiveCalls activeCalls={queue.ActiveCalls}></ActiveCalls>
                : <Typography>No incoming calls</Typography>
            } */}
            
        </Box>
    )
};

const Members = ({ members }) => {
    return (
        <Stack
            direction="row"
            spacing={{ xs: 1, sm: 2 }}
            useFlexGap
            sx={{ flexWrap: 'wrap' }}
        >
            {members.map((member) => {
                return (
                    <Member member={member}></Member>
                )
            })}
        </Stack>
    )
}

const Member = ({ member }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Tooltip
            title={
                <Stack>
                    <Typography>Call taken {member.CallsTaken} calls</Typography>
                    <Typography>Last call {member.LastCall}</Typography>
                </Stack>
            }
            // placement="bottom-start"
        >
            <Stack
                borderRadius={1}
                p={0.2}
                backgroundColor={ member.Status === "1" ? colors.greenAccent[600] : colors.redAccent[600]}
                alignItems={'center'}
            >
                {member.InCall === "0" && member.Status === "1" && <PhoneIcon />}
                {member.InCall === "1" && member.Status === "1" && <PhoneInTalkIcon />}
                
                <Typography>{member.Name}</Typography>
                <Typography>{member.Location}</Typography>
                {member.Status === "0" && <Typography>Unknown state</Typography>}
                {member.Status === "1" && <Typography>Agent is idle</Typography>}
                {member.Status === "2" && <Typography>Agent is on a call</Typography>}
                {member.Status === "5" && <Typography>Extension is unregistered</Typography>}
                {member.Status === "9" && <Typography>Agent is paused</Typography>}
            </Stack>
        </Tooltip>
    )
}

const ActiveCalls = ({ activeCalls }) => {
    return (
        <Box>
            {activeCalls.map((call) => {
                    return (
                        <ActiveCall call={call}></ActiveCall>
                    )
            })}
        </Box>
    )
}

const ActiveCall = ({ call }) => {
    return (
        <Box>
            <Typography>Incoming call: {call.CallerIDNum}, position: {call.Position}, priority: {call.Priority}, wait: {call.Wait}s</Typography>
        </Box>
    )
}

export default QueueStatus;